import React from 'react'
import * as PropTypes from 'prop-types'

const SlackTimePrior = props => {
  const slackTimePriorHeight =
    props.timeToScreen(props.startTime + props.slackTime) - props.timeToScreen(props.startTime)

  if (slackTimePriorHeight === 0) {
    return null
  }

  return <div className="terminal-visit-slack slack-prior" style={{ height: slackTimePriorHeight }} />
}

SlackTimePrior.propTypes = {
  startTime: PropTypes.number.isRequired,
  slackTime: PropTypes.number.isRequired,
  timeToScreen: PropTypes.func.isRequired,
  visitStatus: PropTypes.string
}

export default SlackTimePrior

// Remove this for now, don't know why this was ever implemented
// /**
//  * Determine whether to show (render) slack prior, this depends on the state
//  * @param {TerminalVisit['status']} visitStatus
//  * @return {boolean}
//  */
// function showSlackPrior(visitStatus) {
//   return visitStatus !== VISIT_STATUSES.moored && visitStatus !== VISIT_STATUSES.sailed
// }
